export default __webpack_public_path__ + "static/media/vythri.b0b50e9d.svg";